import { takeEvery } from 'redux-saga/effects';
import config from 'config';
import * as actionTypes from 'modules/Notifications/redux/actionTypes';
import { actionTypes as loginActionTypes } from 'modules/Authorization/redux/login/actions';
import {
  initNotifications,
  fetchMoreNotificationsSaga,
  notificationsSaga,
  onLoginNotificationsSaga,
  readAllNotificationsSaga,
  readNotificationSaga,
  removeAllNotificationsSaga,
  removeNotificationSaga,
  setWatchedSaga,
} from 'modules/Notifications/sagas/notificationsSaga';
import { pollingWatcherSaga } from 'modules/Notifications/sagas/pollNotifications';
import {
  dismissToastGroupSaga,
  dismissToastSaga,
  showToastSaga,
} from 'modules/Notifications/sagas/toastsSaga';
import { hideSidebarSaga, showSidebarSaga } from './sidebarSaga';
import { showModalSaga, closeModalSaga } from './modalSaga';

export default function* notificationsSagas() {
  if (!config.isInspectorArm) {
    yield takeEvery(actionTypes.INITIALIZE_NOTIFICATIONS, initNotifications);
    yield takeEvery(actionTypes.START_NOTIFICATIONS_POLLING, pollingWatcherSaga);
    yield takeEvery(actionTypes.NOTIFICATIONS_READ, readNotificationSaga);
    yield takeEvery(actionTypes.NOTIFICATIONS_REMOVE, removeNotificationSaga);
    yield takeEvery(actionTypes.NOTIFICATIONS_READ_ALL, readAllNotificationsSaga);
    yield takeEvery(actionTypes.NOTIFICATIONS_REMOVE_ALL, removeAllNotificationsSaga);
    yield takeEvery(actionTypes.NOTIFICATIONS_SET_WATCHED, setWatchedSaga);
  }

  if (config.enableNotificationsCenter) {
    yield takeEvery(loginActionTypes.START_WORKING, onLoginNotificationsSaga);
  }

  yield takeEvery(actionTypes.NOTIFICATIONS, notificationsSaga);
  yield takeEvery(actionTypes.NOTIFICATIONS_MORE, fetchMoreNotificationsSaga);
  yield takeEvery(actionTypes.SHOW_TOAST, showToastSaga);
  yield takeEvery(actionTypes.DISMISS_TOAST, dismissToastSaga);
  yield takeEvery(actionTypes.DISMISS_GROUP, dismissToastGroupSaga);
  yield takeEvery(actionTypes.HIDE_SIDEBAR, hideSidebarSaga);
  yield takeEvery(actionTypes.SHOW_SIDEBAR, showSidebarSaga);

  yield takeEvery(actionTypes.SHOW_MODAL, showModalSaga);
  yield takeEvery(actionTypes.CLOSE_MODAL, closeModalSaga);
}
